<template>
  <div class="container is-fullhd">
    <br/>
    <div class="columns">
      <div class="column">
        <div class="box">
          <figure class="image">
            <img data-zoomable src="../assets/card_front.png">
          </figure>
        </div>
      </div>
      <div class="column">
        <div class="box">
          <figure class="image">
            <img data-zoomable src="../assets/card_back.png">
          </figure>
        </div>
      </div>
    </div>
    <div class="button is-info is-fullwidth" @click="$root.$emit('changePage', 'list')">
      <p class="is-uppercase">
        geboortelijst (klik hier)
      </p>
    </div>
    <br/>
    <div class="tile is-ancestor">
  <div class="tile is-vertical is-4">
    <div class="tile is-parent">
      <div class="tile is-child box">
        <figure class="image">
          <img data-zoomable src="../assets/baby_3.jpg">
        </figure>
      </div>
    </div>
    <div class="tile is-parent">
      <div class="tile is-child box">
        <figure class="image">
          <img data-zoomable src="../assets/baby_4.jpg">
        </figure>
      </div>
    </div>
  </div>
  <div class="tile is-vertical is-4">
    <div class="tile is-parent">
      <div class="tile is-child box">
        <figure class="image">
          <img data-zoomable src="../assets/baby_6.jpg">
        </figure>
      </div>
    </div>
    <div class="tile is-parent">
      <div class="tile is-child box">
        <figure class="image">
          <img data-zoomable src="../assets/baby_1.jpg">
        </figure>
      </div>
    </div>
  </div>
  <div class="tile is-vertical is-4">
    <div class="tile is-parent">
      <div class="tile is-child box">
        <figure class="image">
          <img data-zoomable src="../assets/baby_7.jpg">
        </figure>
      </div>
    </div>
    <div class="tile is-parent">
      <div class="tile is-child box">
        <figure class="image">
          <img data-zoomable src="../assets/baby_5.jpg">
        </figure>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import mediumZoom from 'medium-zoom';

export default {
  name: 'Card',
  mounted() {
    mediumZoom('[data-zoomable]');
  },
};
</script>
